import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ReactTelInput from 'react-telephone-input';
import 'react-telephone-input/css/default.css';
import flags from '../../../icons/flags.png';
import styles from './login.module.scss';
import Clickable from '../../../components/clickable/Clickable';

const LoginForm = ({
  handleInputChange,
  handleSignIn,
  errors,
  handleInputBlurred,
  blurredFields,
  cognitoPhoneError,
  url,
  phone,
  handleMailLogin
}) => {
   const [Location, SetLocation] = useState();
   const [isDisabled, setIsDisabled] = useState(false);

   useEffect(() => {
    const fetchLocation = async () => {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });

        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=
          ${position?.coords?.latitude},
          ${position?.coords?.longitude}
          &key=${process.env.REACT_APP_GMAPS_KEY}`
        );

        const responseJson = await response.json();

        if (responseJson.status === 'OK') {
          const country = responseJson?.results[0]?.address_components?.find(
            component => component.types.includes('country')
          );
          // Set country or default to 'us'
          SetLocation(country ? country.short_name.toLowerCase() : 'us');
        } else {
          SetLocation('us');
        }
      } catch (error) {
        SetLocation('us');
      }
    };

    setIsDisabled(Location === undefined);
    fetchLocation();
  }, [Location]);


  return (
  <form name="loginForm" className={styles.login_form} onSubmit={handleSignIn} noValidate>
    <div className={styles.login_form_wrapper}>
     <div className={styles.welcome}>
       { url === '/auth/login' ? <FormattedMessage id="authentication.login.welcome" defaultMessage="Airport Portal" />
           : <FormattedMessage id="authentication.login.authentication" defaultMessage="Authentication" />
       }
     </div>
    <div className={styles.login_message}>Login to your account</div>
    <div className={styles.column_wrapper}>
      <div className={styles.form_column}>
        <label htmlFor="phone">
          {Location && <ReactTelInput
            type="text"
            id="phone"
            flagsImagePath={flags}
            onChange={(e) => { handleInputChange('phone', e); }}
            onBlur={() => { handleInputBlurred('phone'); }}
            name="phone number"
            required value={phone} classNames={styles.telephoneInput}
            defaultCountry={Location||'us'} placeholder="Phone Number"
            inputProps={{ placeholder: 'Enter Phone Number' }}
          />}
          <div className={styles.circle_green} />
         <span className={styles.formLabelText}>Please enter your phone number</span>
        </label>
        {blurredFields.phone && errors.phoneEmpty ? (
          <small className={styles.error}>
            <FormattedMessage id="authentication.login.error.email_empty" defaultMessage="This field cannot be empty" />
          </small>
        ) : null}
        {blurredFields.phone && cognitoPhoneError ? (
          <small className={styles.error}>
            <FormattedMessage
              id="authentication.login.cognito.phone_error"
              defaultMessage={`The phone number you entered is not registered in the system.
                Please try again with another number or contact your system administrator.`}
            />
          </small>
        ) : null}
        {!blurredFields.phone || (!errors.phoneEmpty && !errors.phoneInvalid) ? (
          <small className={styles.empty_error} />
        ) : null}
        {/* <label htmlFor="loginPassword">
          <div className={styles.form_control}>
          <input
            placeholder="Password"
            type="password"
            name="loginPassword"
            required
            value={ password }
            onChange={(e) => { handleInputChange('password', e.target.value); }}
            onBlur={() => { handleInputBlurred('password'); }}
          />
            <div className={styles.circle_red}/>
          </div>
          { blurredFields.password && errors.passwordEmpty ? (
            <small className={styles.error}>
              <FormattedMessage id="authentication.login.error.password_empty" defaultMessage="This field cannot be empty" />
            </small>) : <small className={styles.empty_error} />
          }
        </label> */}
      </div>
    </div>
      {/* <div className={styles.checkbox_custom}>
        <Checkbox label={<label>Remember me</label>} onChange={onChangeRememberMe} checked={isRemember} />
      </div> */}
    {errors.invalidCredentials ? (
      <div className={`${styles.error} ${styles.invalid_credentials}`}>
        <FormattedMessage id="authentication.login.error.invalid_credentials" defaultMessage="Invalid Credentials" />
      </div>) : null}
      <div className={styles.button_wrapper}>
      <button
        type="submit"
        className={styles.button}
        disabled={isDisabled}
      >
        <FormattedMessage id="authentication.login.get_code" defaultMessage="Get Code" />
      </button>
      </div>
      {/* <div className={styles.forgot_password_custom}>
        <Clickable onClick={() => handleLoginWithPassword()} className={styles.forgot_password}>
          <FormattedMessage id="authentication.login.with_password" defaultMessage="Login with password" />
        </Clickable>
      </div> */}
      <div className={styles.forgot_password_custom}>
        <Clickable onClick={() => handleMailLogin()} className={styles.forgot_password}>
        <FormattedMessage id="authentication.login.get_code1" defaultMessage="Login with mail" />
        </Clickable>
      </div>
      {/* <div className={styles.forgot_password_custom}>
        <Clickable onClick={() => handleForgotPassword()} className={styles.forgot_password}>
          <FormattedMessage id="forgot_password" defaultMessage="Forgot password?" />
        </Clickable>
      </div> */}
      {/* <div className={styles.forgot_password_custom}>
        <Clickable onClick={() => handleOTPLogin()} className={styles.forgot_password}>
          <FormattedMessage id="otp_login" defaultMessage="OTP Login" />
        </Clickable>
      </div> */}
    </div>
  </form>
  );
};


LoginForm.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  handleSignIn: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    emailValid: PropTypes.bool
  }).isRequired,
  blurredFields: PropTypes.shape({
    emailValid: PropTypes.bool
  }).isRequired,
  handleInputBlurred: PropTypes.func.isRequired
};

export default LoginForm;
